<main>
  <div class="container-fluid">
    <h1 class="mt-4">Ideals</h1>
    <ol class="breadcrumb mb-4">
      <li class="breadcrumb-item active">Ideals</li>
    </ol>
    <div class="clearfix"></div>
  </div>
  <div class="clearfix"></div>

  <div class="col-12 mb-4 actions">
    <button type="button" class="btn btn btn-primary" (click)="openCreateMockupModal('')">
      <i class="far fa-plus-square"></i>
      Tạo Ideals
    </button>

    <button class="btn btn-success ml-2" (click)="openAddToAccountModal()" *ngIf="userData.fromSellerToAbove">
      <i class="fas fa-cloud-upload-alt"></i>
      Add to Account
      <span *ngIf="queue.length > 0" class="badge badge-light ml-2">{{queue.length}}</span>
    </button>

    <app-bulk-upload-ideals (uploadCompleted)="queryMockups(1)"></app-bulk-upload-ideals>

  </div>
  <div class="clearfix"></div>

  <div class="col-12 mb-4 actions">
    <button type="button" class="btn-custom btn-outline-info-custom mr-1" (click)="toggleQuickFilter(0)"
      [class.active]="query.quickFilter == 0">
      <i class="far fa-lightbulb"></i>
      Backlog
      <span class="badge badge-info">{{queryResult.backlogCount}}</span>
    </button>
    <button type="button" class="btn-custom btn-outline-warning-custom mr-1" (click)="toggleQuickFilter(1)"
      [class.active]="query.quickFilter == 1">
      <i class="fas fa-paint-roller"></i>
      Chờ Des
      <span class="badge badge-warning">{{queryResult.waitingForDesCount}}</span>
    </button>
    <button type="button" class="btn-custom btn-outline-success-custom mr-1" (click)="toggleQuickFilter(2)"
      [class.active]="query.quickFilter == 2">
      <i class="fas fa-thermometer"></i>
      Chờ Duyệt
      <span class="badge badge-success">{{queryResult.waitingApprovalCount}}</span>
    </button>
    <button type="button" class="btn-custom btn-outline-info-custom mr-1" (click)="toggleQuickFilter(3)"
      [class.active]="query.quickFilter == 3">
      <i class="fas fa-check-square"></i>
      Done
    </button>
  </div>

  <div class="col-12">

    <table class="table table-bordered table-hover mockup-table">
      <tr>
        <td class="text-center" width="100px">
          <input class="form-control form-control-sm" [owlDateTimeTrigger]="createdDate" [owlDateTime]="createdDate"
            [(ngModel)]="query.createdDate" (ngModelChange)="queryMockups()" placeholder="Ngày tạo">
          <owl-date-time [pickerType]="'calendar'" #createdDate></owl-date-time>
        </td>
        <td width="350px" colspan="2">
          <input class="form-control form-control-sm" [(ngModel)]="query.queryString" (ngModelChange)="queryMockups()"
            placeholder="Tìm kiếm">
        </td>
        <td width="250px">
          <div class="filter-container">
            <ng-select [items]="merchantGroups" bindLabel="name" bindValue="id" placeholder="Tất cả nhóm"
              [(ngModel)]="query.merchantGroupId" (change)="queryMockups()" name="merchantGroupFilter" class="mb-2">
            </ng-select>
            <ng-select [items]="merchants" bindLabel="name" bindValue="merchantId" placeholder="Merchant đã đăng hàng"
              [(ngModel)]="query.postedMerchantId" (change)="queryMockups()" name="postedMerchantFilter">
            </ng-select>
          </div>
        </td>
        <td class="text-center" width="150px"></td>
      </tr>

      <tr>
        <th class="text-center" width="100px">Ngày tạo</th>
        <th width="350px">Sku - Name</th>
        <th>Images</th>
        <th width="150px">Nhóm/Designer</th>
        <th class="text-center" width="250px">Actions</th>
      </tr>
      <tbody>
        <tr *ngFor="let mockup of queryResult.items">
          <td class="text-center">
            {{mockup.createdDateString}}
            <br />
            {{mockup.createdTimeString}}
          </td>
          <td>
            <strong>{{mockup.sku}}</strong>
            <br />
            <div *ngIf="getTrademarkMatches(mockup.id).length > 0" class="trademark-highlight-container">
              <span [innerHTML]="highlightTrademarksInName(mockup.name, mockup.id)"></span>
            </div>
            <app-editable [data]="mockup.name" [dataType]="'textarea'"
              (focusOut)="updateSingleValue(mockup, 'Name', $event)">
            </app-editable>
          </td>
          <td>
            <div class="image-container">
              <img *ngFor="let thumbnail of mockup.thumbnails.slice(0, 3)" [src]="thumbnail.thumbUrl" alt="Preview"
                class="preview-image" />
            </div>
          </td>
          <td>
            <strong>{{mockup.merchantGroupName}}</strong>
            <br />
            {{mockup.designerName}}
            <br />
            Điểm design: <strong>{{mockup.desPoint}}</strong>
            <br />
            <i *ngIf="mockup.currentlyDesign" class="fas fa-play" style="color: #74C0FC;"></i>

            <br />
            <strong>Merchants:</strong>
            <div *ngFor="let linkedMerchant of mockup.linkedMerchants">
              {{linkedMerchant.name}}
            </div>
          </td>
          <td class="text-center">
            <button class="btn-custom btn-outline-info-custom" (click)="openCreateMockupModal(mockup)"
              *ngIf="mockup.progressState == 0" title="Backlog">
              <i class="far fa-lightbulb"></i>
              Backlog
            </button>

            <button class="btn-custom btn-outline-warning-custom" (click)="openCreateMockupModal(mockup)"
              *ngIf="mockup.progressState == 1" title="Chờ Des">
              <i class="fas fa-paint-roller"></i>
              Chờ Des
            </button>

            <button class="btn-custom btn-outline-success-custom" (click)="openCreateMockupModal(mockup)"
              *ngIf="mockup.progressState == 2" [class.text-red]="mockup.stillGetLink" title="Chờ Duyệt">
              <i class="fas fa-thermometer"></i>
              Chờ Duyệt
            </button>

            <button class="btn-custom btn-outline-info-custom" (click)="openCreateMockupModal(mockup)"
              *ngIf="mockup.progressState == 3" title="Done">
              <i class="fas fa-check-square"></i>
              Done
            </button>

            <br />
            <br />
            <div class="btn-group">
              <button class="btn-custom btn-outline-success-custom" (click)="addToQueue(mockup)">
                <i class="fa fa-cloud-upload-alt"></i>
                {{ isInQueue(mockup) ? 'Remove from Queue' : 'Add to Queue' }}
              </button>
            </div>

            <br />
            <br />
            <button class="btn-custom btn-outline-danger-custom" (click)="confirmDeleteMockup(mockup)"
              *ngIf="userData.fromSellerToAbove" title="Xóa">
              <i class="fas fa-trash"></i>
              Xóa
            </button>
          </td>
        </tr>
      </tbody>
    </table>

    <app-pagination [(pageNumber)]="query.pageNumber" [pageSize]="query.pageSize" [totalItems]="queryResult.total"
      (onPageChanged)="queryMockups($event)">
    </app-pagination>

  </div>
</main>

<ng-template #mockupModal let-modal>
  <div class="mockupModal">
    <div class="modal-header">
      <h4 class="modal-title" id="modal-basic-title">
        Mockup
      </h4>
    </div>

    <div class="modal-body">
      <form name="mockupForm">
        <div class="row">
          <div class="col-6">
            <div class="form-row">
              <div class="form-group col-6">
                <label class="col-form-label-sm">Sku</label>
                <input type="text" class="form-control form-control-sm" name="sku" [(ngModel)]="mockupDetail.sku"
                  (change)="updateSingleValue(mockupDetail, 'Sku', mockupDetail.sku);" />
              </div>
              <div class="form-group col-6">
                <label class="col-form-label-sm">Nhóm</label>

                <ng-select [items]="mockupDetail.availableMerchantGroups" placeholder="Toàn bộ các team" bindValue="id"
                  bindLabel="name" [(ngModel)]="mockupDetail.merchantGroupId"
                  (change)="updateSingleValue(mockupDetail, 'Group', mockupDetail.merchantGroupId)"
                  name="merchantGroupId">
                </ng-select>
              </div>
            </div>

            <div class="form-row">
              <div class="form-group col-12 w-100">
                <label class="col-form-label-sm">Tên</label>
                <div class="input-group">
                  <input type="text" class="form-control form-control-sm" name="name" [(ngModel)]="mockupDetail.name"
                    (change)="updateSingleValue(mockupDetail, 'Name', mockupDetail.name)" />
                  <button class="btn btn-sm btn-outline-info" type="button" (click)="checkTrademark()"
                    [disabled]="checkingTrademark" title="Check Trademark">
                    <i class="fas fa-trademark"></i>
                    <span class="spinner-border spinner-border-sm" *ngIf="checkingTrademark"></span>
                  </button>
                </div>
                <div *ngIf="trademarkCheckResult" class="mt-2">
                  <div *ngIf="trademarkCheckResult.databaseWarnings && trademarkCheckResult.databaseWarnings.length > 0"
                    class="alert alert-warning mb-2">
                    <strong><i class="fas fa-database"></i> Database Warnings:</strong>
                    <ul class="mb-0 mt-1">
                      <li *ngFor="let warning of trademarkCheckResult.databaseWarnings">
                        <strong>{{warning.text}}</strong>
                        <span *ngIf="warning.note"> - {{warning.note}}</span>
                      </li>
                    </ul>
                  </div>
                  <div *ngIf="trademarkCheckResult.geminiWarnings && trademarkCheckResult.geminiWarnings.length > 0"
                    class="alert alert-info mb-2">
                    <strong><i class="fas fa-robot"></i> Gemini AI Warnings:</strong>
                    <ul class="mb-0 mt-1">
                      <li *ngFor="let warning of trademarkCheckResult.geminiWarnings">
                        {{warning.text}}
                        <span *ngIf="warning.note" class="text-muted"> ({{warning.note}})</span>
                      </li>
                    </ul>
                  </div>
                  <div
                    *ngIf="(!trademarkCheckResult.databaseWarnings || trademarkCheckResult.databaseWarnings.length === 0) && 
                              (!trademarkCheckResult.geminiWarnings || trademarkCheckResult.geminiWarnings.length === 0)"
                    class="alert alert-success mb-2">
                    <i class="fas fa-check-circle"></i> No trademark issues found.
                  </div>
                </div>
              </div>
            </div>

            <div class="form-row">
              <div class="form-group col-12 w-100">
                <label class="col-form-label-sm">Mô tả</label>
                <textarea rows="5" class="form-control form-control-sm" name="description"
                  [(ngModel)]="mockupDetail.description"
                  (change)="updateSingleValue(mockupDetail, 'Description', mockupDetail.description)"></textarea>
              </div>
            </div>

            <div class="form-row">
              <label class="col-form-label-sm">Ảnh demo</label>
              <div class="col-12">
                <app-images-show [images]="mockupDetail.thumbnails"></app-images-show>
              </div>
            </div>

            <div class="form-row">
              <div class="form-group col-12 w-100">
                <label class="col-form-label-sm">Note</label>
                <textarea rows="3" class="form-control form-control-sm" name="note" [(ngModel)]="mockupDetail.note"
                  (change)="updateSingleValue(mockupDetail, 'Note', mockupDetail.note)"></textarea>
              </div>
            </div>

            <div class="form-row">
              <div class="form-group col-12 w-100">
                <label class="col-form-label-sm">Link sản phẩm chọn:</label>
                <textarea rows="3" class="form-control form-control-sm" name="selectDesLink"
                  [(ngModel)]="mockupDetail.destinationProductLink"></textarea>
              </div>
            </div>



            <div class="row mt-36 no-padding-side left-actions">

              <div class="col-4 mt-36" *ngIf="mockupDetail.progressState== 0
                   || mockupDetail.progressState== 1">
                <button class="btn btn-info" (click)="passToBacklog()">
                  <i class="fas fa-save"></i>
                  Chuyển Backlog
                </button>
              </div>

              <div class="col-4" *ngIf="mockupDetail.progressState == 0
                        || mockupDetail.progressState == 2">
                <ng-select [items]="mockupDetail.availableDesigners" bindLabel="userName" bindValue="id"
                  placeholder="Designers" [(ngModel)]="mockupDetail.designerId" name="desId">
                </ng-select>

                <button class="btn btn-warning" (click)="passToDesigner()">
                  <i class="fas fa-paint-roller"></i>
                  Chuyển Designer
                </button>
              </div>

              <div class="col-4 mt-36" *ngIf="mockupDetail.progressState== 1">
                <button class="btn btn-success" (click)="passToApproval()">
                  <i class="fas fa-thermometer"></i>
                  Chuyển sang Chờ Duyệt
                </button>
              </div>

              <div class="col-4 mt-36" *ngIf="mockupDetail.progressState== 2">
                <button class="btn btn-info" (click)="passToDone()">
                  <i class="fas fa-check-square"></i>
                  Chuyển sang Done
                </button>
              </div>

            </div>

            <div class="row no-padding-side">
              <div class="col-12 mt-10 saleRecordLogs">
                <p *ngFor="let log of logs">
                  {{log.createdString}} - <span [innerHTML]="log.logMessage"></span>
                </p>
              </div>
            </div>

          </div>

          <div class="col-6 text-left">
            <app-log-time [targetId]="mockupDetail.id" [type]="'Design'" [readonly]="mockupDetail.progressState != 1"
              (stopTimerEvent)="recalculateDesPoint($event)" (timerRunningChanged)="assignTimerRunning($event)">
            </app-log-time>
            <br />
            <div class="col-12">
              <div class="col-12">
                Điểm design: <strong>{{mockupDetail.desPoint}}</strong>
              </div>
            </div>

            <hr />
            <div class="uploadDesign" *ngIf="mockupDetail.progressState == 1">
              <app-upload-design
                [disabled]="uploadProgress"
                (submitDesign)="onSubmitDesignFiles($event)">
              </app-upload-design>
              <img class="loader" *ngIf="uploadProgress" src="/content/loading.gif" />
            </div>
            <div class="mt-10" *ngFor="let demoImageLink of temptPreviewImages; let i = index"
              [hidden]="temptPreviewImages.length == 0">
              <div class="preview-container">
                <img [src]="demoImageLink == null ? global.imgHodlder : demoImageLink"
                  class="img-fluid show-trans-image preview-image" />
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
</ng-template>

<ng-template #addToAccountModal let-modal>
  <div class="modal-header">
    <h4 class="modal-title">Add to Account</h4>
    <button type="button" class="close" aria-label="Close" (click)="modal.dismiss()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <form>
      <div class="form-group">
        <label>Select Merchant</label>
        <ng-select [items]="merchants" bindLabel="name" bindValue="merchantId" placeholder="Select a merchant"
          (change)="onMerchantChange($event)" name="merchant">
        </ng-select>
      </div>

      <div class="form-group">
        <label>Select Template</label>
        <ng-select [items]="merchantTemplates" bindLabel="configName" bindValue="id" placeholder="Select a template"
          [(ngModel)]="selectedTemplate" [disabled]="!selectedMerchant" name="template">
        </ng-select>
      </div>

      <div class="form-group">
        <div class="custom-control custom-checkbox">
          <input type="checkbox" class="custom-control-input" id="overrideDescription"
            [(ngModel)]="accountOptions.overrideDescription" name="overrideDescription">
          <label class="custom-control-label" for="overrideDescription">
            Override Description with product value
          </label>
        </div>
      </div>

      <div class="form-group">
        <div class="custom-control custom-checkbox">
          <input type="checkbox" class="custom-control-input" id="useAIName" [(ngModel)]="accountOptions.useAIName"
            name="useAIName">
          <label class="custom-control-label" for="useAIName">
            Use AI to rewrite Name
          </label>
        </div>
      </div>

      <div class="form-group">
        <div class="custom-control custom-checkbox">
          <input type="checkbox" class="custom-control-input" id="useAIDescription"
            [(ngModel)]="accountOptions.useAIDescription" name="useAIDescription">
          <label class="custom-control-label" for="useAIDescription">
            Use AI to rewrite Description
          </label>
        </div>
      </div>

      <div class="queue-summary mt-4">
        <h5>Items in Queue ({{queue.length}})</h5>
        <div class="queue-items">
          <div *ngFor="let item of queue.slice(0, 3)" class="queue-item">
            <strong>{{item.sku}}</strong> - {{item.name}}
          </div>
          <div *ngIf="queue.length > 3" class="queue-item ellipsis">
            ... and {{queue.length - 3}} more items
          </div>
        </div>
      </div>
    </form>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-secondary" (click)="modal.dismiss()">Cancel</button>
    <button type="button" class="btn btn-primary" (click)="processQueue()"
      [disabled]="!selectedMerchant || !selectedTemplate">
      Process Queue
    </button>
  </div>
</ng-template>

<app-confirm-action [confirmMessage]="'Bạn có chắc muốn xóa mockup này?'" (action)="deleteMockup()"
  [openModal]="openConfirmDeleteMockupAction">